module.exports = __webpack_public_path__ + "static/media/schedule.9c151065.png";